import { describeResource } from '@siteless/resource';
import { z } from 'zod';
import { CurrentUserResourceType } from './Auth/CurrentUser';
import { browserStorageSafe } from '../util/browserStorageSafe';

export let browserStorageKey = 'browserStorage' as const;

export let BrowserStorageResourceSchema = z.object({
  promotionLinkStarWars2023: z.optional(z.boolean()),
  leaguesToJoinIds: z.optional(z.array(z.string())),
  lastLoginMethod: z.optional(z.custom<CurrentUserResourceType['authProvider']>()),
  lastRoute: z.optional(z.string()),
  dismissedSpectatorNotificationForYears: z.optional(z.record(z.string(), z.boolean())),
  dismissedWrapBannerForYears: z.optional(z.record(z.string(), z.boolean())),
}).optional()

export type BrowserStorageResourceType = z.infer<
  typeof BrowserStorageResourceSchema
>;

export let writeBrowserStorage = async (writeWith: (last: BrowserStorageResourceType) => BrowserStorageResourceType,) => {
  let next = writeWith(
    await BrowserStorageResource.UNSTABLE__getFromStoreOrGet(undefined),
  );

  browserStorageSafe.setItem(browserStorageKey, JSON.stringify(next));
}

export let BrowserStorageResource = describeResource('BrowserStorageResource', {
  get: async () => {
    return BrowserStorageResourceSchema.parse(
      JSON.parse(browserStorageSafe.getItem(browserStorageKey) || JSON.stringify({})),
    );
  },
});
